<template>
  <div class="authority" >
    <el-row style="margin-bottom: .2rem">
      <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="handleAddOpen">新增角色</el-button>
      <a href="/setting_panel">
        <el-button type="primary" size="mini">返回上一级</el-button>
      </a>
    </el-row>
    <el-row class="m-con">
      <el-col class="role-list" :span="4">
        <el-input
          size="small"
          placeholder="请输入角色名称"
          suffix-icon="el-icon-search"
          v-model="search">
        </el-input>
        <div class="list">
          <div class="pb15" :class="{'active-role':active_role === item.id}" v-for="(item, index) in filterRoles" :key="index">
            <i class="el-icon-user"></i>
            <span class="sel-role" @click="selectRole(index, item)">{{item.role_name}}</span>
            <el-dropdown trigger="click" @command="handleCommand" class="more-icon">
              <span class="el-dropdown-link"><i class="el-icon-s-fold"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{action: 'edit', index: index, id: item.id}">修改角色</el-dropdown-item>
                <el-dropdown-item :command="{action: 'show', index: index, id: item.id}">查看人员</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-tab-pane label="配置菜单" name="show">
            <div v-if="!active_role" class="node-empty"><p>暂无数据</p></div>
            <div class="node-con" v-else>
              <el-collapse v-model="activeCollapse" v-for="(cate, index) in menus2" :key="cate.id">
                <el-collapse-item :name="index">
                  <template slot="title">
                    <span class="check-title">{{cate.cateName}}</span>
                    <el-checkbox v-model="cate.checkAll" @change="handleCateCheckAllChange(cate.checkAll, index)">全选</el-checkbox>
                  </template>
                  <el-checkbox-group size="small" v-model="cate.cateCheckeds" @change="handleCheckedCateChange(cate.cateCheckeds, index)">
                    <el-checkbox v-for="action in cate.child" :label="action.id" :key="action.id" border>{{action.menu_name}}</el-checkbox>
                  </el-checkbox-group>
                </el-collapse-item>
              </el-collapse>
              <el-collapse value="1">
                <el-collapse-item name="1">
                  <template slot="title">
                    <span class="check-title">一级菜单</span>
                    <el-checkbox v-model="checkAll" @change="handleMenusCheckAllChange">全选</el-checkbox>
                  </template>
                  <el-checkbox-group size="small" v-model="checkedMenus" @change="handleCheckedMenusChange">
                    <el-checkbox v-for="menu in menus1" :label="menu.id" :key="menu.id" border>{{menu.menu_name}}</el-checkbox>
                  </el-checkbox-group>
                </el-collapse-item>
              </el-collapse>
              <el-row class="tr mt10">
                <el-button type="primary" size="mini" @click="handleSaveMenu">保存</el-button>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="配置权限" name="post">
            <div v-if="!active_role" class="node-empty"><p>暂无数据</p></div>
            <div class="node-con" v-else>
              <el-collapse v-model="activeCollapse1" v-for="(box, index) in checkBox" :key="box.id">
                <el-collapse-item :name="index">
                  <template slot="title">
                    <span class="check-title">{{box.menu_name}}</span>
                    <el-checkbox v-model="box.checkAll" @change="handleCheckAllChange(box.checkAll, index)">全选</el-checkbox>
                  </template>
                  <el-checkbox-group size="small" v-model="box.checkedNodes" @change="handleCheckedCitiesChange(box.checkedNodes, index)">
                    <el-checkbox v-for="action in box.nodes" :label="action.id" :key="action.id" border>{{action.node_name}}</el-checkbox>
                  </el-checkbox-group>
                </el-collapse-item>
              </el-collapse>
              <el-row class="tr mt10">
                <el-button type="primary" size="mini" @click="handleSaveNode">保存</el-button>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog
      title="添加角色"
      :visible.sync="addDialogVisible"
      width="40%"
      :before-close="handleAddClose">
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px">
        <el-form-item label="角色名称" prop="role_name">
          <el-input size="small" v-model="addForm.role_name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAddForm('addForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑角色"
      :visible.sync="editDialogVisible"
      width="40%"
      :before-close="handleEditClose">
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px">
        <el-form-item label="角色名称" prop="role_name">
          <el-input size="small" v-model="editForm.role_name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitEditForm('editForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="role_name" width="50%" :visible.sync="roleVisible">
      <el-row>
        <el-col :span="2" v-for="(item, index) in users" :key="index" :offset="index % 8 === 0 ? 0 : 1">
          <div class="demo-basic--circle">
            <div class="block"><el-avatar :size="40" :src="avatarHost + item.buphoto"></el-avatar></div>
            <el-tooltip :content="item.username" placement="top">
              <p class="avatar-name">{{item.username}}</p>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Authority',
  data () {
    return {

      role_name: '',
      roleVisible: false,
      users: [],
      activeName: 'show',
      search: '',
      roles: [],
      active_role: null,
      addDialogVisible: false,
      editDialogVisible: false,
      activeCollapse: [],
      activeCollapse1: [],
      addForm: {
        role_name: ''
      },
      editForm: {
        id: null,
        index: null,
        role_name: ''
      },
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      checkBox: [
        {
          id: 1,
          menu_name: '首页',
          nodes: [
            {
              id: 1,
              node_name: '创建'
            },
            {
              id: 2,
              node_name: '编辑'
            },
            {
              id: 3,
              node_name: '删除'
            }
          ],
          checkAll: false,
          checkedNodes: [1]
        },
        {
          id: 2,
          menu_name: '用户',
          nodes: [
            {
              id: 1,
              node_name: '创建'
            },
            {
              id: 2,
              node_name: '编辑'
            },
            {
              id: 3,
              node_name: '删除'
            }
          ],
          checkAll: false,
          checkedNodes: []
        }
      ],
      menus1: [],
      menus2: [],
      checkAll: false,
      checkedMenus: []
    }
  },
  computed: {
    filterRoles: {
      get: function () {
        return this.roles.filter(data => !this.search || data.role_name.toLowerCase().includes(this.search.toLowerCase()))
      }
    },
    avatarHost: {
      get: function () {
        return process.env.NODE_ENV === 'development' ? 'http://www.qyh.com/uploads/adminuser/' : 'https://www.qiyehuo.com/uploads/adminuser/'
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    menus2: function () {
      for (var i = 0; i < this.menus2.length; i++) {
        this.activeCollapse.push(i)
      }
    },
    checkBox: function () {
      for (var i = 0; i < this.checkBox.length; i++) {
        this.activeCollapse1.push(i)
      }
    }
  },
  methods: {
    getRoles () {
      this.$axios.get('/api/admin/roles')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.roles = data.data.roles
            this.menus1 = data.data.menus1
            this.menus2 = data.data.cateData
          }
        })
    },
    handleAddOpen () {
      this.addDialogVisible = true
    },
    handleAddClose () {
      this.addDialogVisible = false
      this.resetForm('addForm')
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    selectRole (index, row) {
      this.$axios.post('/api/admin/role/nodes/' + row.id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.checkBox = data.data.menus
            this.setMenuCheckds(data.data.checkedMenus)
            this.active_role = row.id
          }
        })
    },
    setMenuCheckds (arr) {
      for (var i = 0; i < this.menus2.length; i++) {
        this.menus2[i].cateCheckeds = []
        for (var j = 0; j < this.menus2[i].child.length; j++) {
          if (arr.indexOf(this.menus2[i].child[j].id) !== -1) {
            this.menus2[i].cateCheckeds.push(this.menus2[i].child[j].id)
          }
        }

        this.menus2[i].checkAll = this.menus2[i].cateCheckeds.length === this.menus2[i].child.length
      }

      this.checkedMenus = []
      for (var k = 0; k < this.menus1.length; k++) {
        if (arr.indexOf(this.menus1[k].id) !== -1) {
          this.checkedMenus.push(this.menus1[k].id)
        }
      }

      this.checkAll = this.menus1.length === this.checkedMenus.length
    },
    handleCommand (command) {
      command.action === 'show' ? this.handleShowUsers(command.index, command.id) : this.handleEditOpen(command.index, command.id)
    },
    handleEditOpen (index, id) {
      this.editForm.id = id
      this.editForm.index = index
      this.editForm.role_name = this.filterRoles[index].role_name
      this.editDialogVisible = true
    },
    submitAddForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/roles', this.addForm)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.roles.push(data.data)
                this.handleAddClose()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleEditClose () {
      this.editDialogVisible = false
      this.editForm.id = null
      this.editForm.index = null
      this.editForm.role_name = ''
    },
    submitEditForm (formName) {
      if (this.filterRoles[this.editForm.index].role_name === this.editForm.role_name) {
        this.handleEditClose()
        return
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.put('/api/admin/role/' + this.editForm.id, {role_name: this.editForm.role_name})
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.filterRoles[this.editForm.index].role_name = this.editForm.role_name
                this.handleEditClose()
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handleShowUsers (index) {
      this.$axios.get('/api/admin/role/users/' + this.roles[index].id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.role_name = this.roles[index].role_name
            this.users = data.data.users
            this.roleVisible = true
          }
        })
    },
    handleCheckAllChange (val, index) {
      if (val) {
        this.checkBox[index].checkAll = true
        let checkedArr = this.getCheckedArr(index)
        this.checkBox[index].checkedNodes = checkedArr
      } else {
        this.checkBox[index].checkAll = false
        this.checkBox[index].checkedNodes = []
      }
    },
    getCheckedArr (index) {
      let arr = []
      let nodes = this.checkBox[index].nodes
      for (var i = 0; i < nodes.length; i++) {
        arr.push(nodes[i].id)
      }

      return arr
    },
    handleCheckedCitiesChange (value, index) {
      let checkedCount = value.length
      this.checkBox[index].checkAll = checkedCount === this.checkBox[index].nodes.length
    },
    handleSaveNode () {
      let checkArr = []
      for (var i = 0; i < this.checkBox.length; i++) {
        checkArr.push(this.checkBox[i].checkedNodes)
      }

      this.$axios.put('/api/admin/role/nodes/' + this.active_role, {checkArr: checkArr})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleTabsClick (tab, event) {},
    handleMenusCheckAllChange (val) {
      this.checkedMenus = val ? this.getMenuArr() : []
    },
    getMenuArr () {
      let arr = []
      for (var i = 0; i < this.menus1.length; i++) {
        arr.push(this.menus1[i].id)
      }

      return arr
    },
    handleCheckedMenusChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.menus1.length
    },
    handleCateCheckAllChange (val, index) {
      if (val) {
        this.menus2[index].checkAll = true
        let checkedArr = this.getCateCheckedArr(index)
        this.menus2[index].cateCheckeds = checkedArr
      } else {
        this.menus2[index].checkAll = false
        this.menus2[index].cateCheckeds = []
      }
    },
    getCateCheckedArr (index) {
      let arr = []
      let menus = this.menus2[index].child
      for (var i = 0; i < menus.length; i++) {
        arr.push(menus[i].id)
      }

      return arr
    },
    handleCheckedCateChange (value, index) {
      let checkedCount = value.length
      this.menus2[index].checkAll = checkedCount === this.menus2[index].child.length
    },
    handleSaveMenu () {
      let checkArr = []
      for (var i = 0; i < this.menus2.length; i++) {
        checkArr.push(this.menus2[i].cateCheckeds)
      }

      this.$axios.post('/api/admin/role/menus/' + this.active_role, {checkArr: checkArr, checkedMenus: this.checkedMenus})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getRoles()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .authority >>> .el-tabs__header
    padding-left: .4rem
  .authority >>> .el-tabs__nav-wrap::after
    display:none !important
  .el-checkbox.is-bordered
    margin-bottom: .2rem
  .authority
    marginLeft()
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .mtb30
      margin-bottom: .6rem
    .mt10
      margin-top: .2rem
    .pb15
      padding-bottom: .3rem
    .role-list
      min-height: calc(100vh - 210px)
      padding-right: 12px
      border-right: 1px solid #ebebeb
      .list
        margin-top: .3rem
    .more-icon
      float: right
      color: #5789F4
      cursor: pointer
    .sel-role
      cursor: pointer
    .active-role
      color: #5789f4
    .node-header
      line-height: .88rem
      padding-left: .4rem
      margin-bottom: .3rem
      color: #5789F4
    .node-empty
      text-align: center
      color: rgba(0, 0, 0, .3)
    .node-con
      padding-left: .4rem
    .check-title
      margin-right: .4rem
    .tr
      text-align: right
    .el-checkbox.is-bordered+.el-checkbox.is-bordered
      margin-left: 0
</style>



// WEBPACK FOOTER //
// src/pages/authority/Authority.vue